import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Erase = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Erase' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M7,21 L22,6 L18,2 L2,18 L5,21 L19,21 M6,14 L10,18' />
  </StyledIcon>
);
